import { ComponentType, type IConfig } from '../../types';
import { config as SimpleTriggerActionButtonConfig } from '../simple-trigger-action-button/config';
import { ComponentConfigType } from '../../utils/data-parser';
import {
  BASIC_VALUE_TOOLTIP,
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.TriggerActionButton,
  configGroups: [
    ...SimpleTriggerActionButtonConfig.configGroups,
    {
      title: 'Action form',
      items: [
        {
          name: 'actionForm.show',
          label: 'Action form show',
          valueComponent: { type: 'Switch', defaultValue: false },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'actionForm.title',
          label: 'Action Form Title',
          valueComponent: {
            type: 'Input',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'actionForm.modalWidth',
          label: 'Action Form Modal Width',
          valueComponent: {
            type: 'InputNumber',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'actionForm.cancelText',
          label: 'Cancel Button Text',
          valueComponent: {
            type: 'Input',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'actionForm.confirmText',
          label: 'Save Button Text',
          valueComponent: {
            type: 'Input',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'actionForm',
          label: 'Action Form',
          valueComponent: {
            type: 'ChildSchemaEditor',
          },
          configTypes: [],
          tooltips: [],
        },
      ],
    },
  ],
};
